import webContextProvider from "../../../../../providers/webContextProvider";

export default () => {
  const { browseCountry, browseCurrency } = webContextProvider();

  return `${browseCountry}|${browseCurrency}`;
};
